/* Compact countdown to 00:00 UTC, shown alongside the keyboard after
   the game ends. Same tick cadence as PuzzleStatus / NoPuzzleToday
   (self-correcting once per second). The big monospace digits read
   as a celebratory "your next puzzle drops in…" beat next to the
   greyed-out keyboard. */

import { useEffect, useState } from "preact/hooks";
import { formatHms, msUntilNextUtcMidnight } from "../game/countdown";

export function NextPuzzleCountdown() {
  const [hms, setHms] = useState(() => formatHms(msUntilNextUtcMidnight()));
  useEffect(() => {
    const tick = () => setHms(formatHms(msUntilNextUtcMidnight()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  return (
    <div class="next-puzzle" aria-live="polite">
      <p class="next-puzzle__label">Next puzzle in</p>
      <p
        class="next-puzzle__hms"
        aria-label={`Next puzzle in ${hms}`}
      >
        {hms}
      </p>
    </div>
  );
}
